// extracted by mini-css-extract-plugin
module.exports = {"container":"AreaIcon_container__M6T3C"};